{
  "name": "tecnogru-manager",
  "version": "0.0.40",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "testserver": "ng build  --configuration testserver --base-href=/manage/",
    "buildfolder": "ng build --base-href=/manage/",
    "buildcatia": "ng build --configuration development --base-href=/manage/"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.1",
    "@angular/common": "^19.2.1",
    "@angular/compiler": "^19.2.1",
    "@angular/core": "^19.2.1",
    "@angular/forms": "^19.2.1",
    "@angular/platform-browser": "^19.2.1",
    "@angular/platform-browser-dynamic": "^19.2.1",
    "@angular/router": "^19.2.1",
    "@angular/service-worker": "^19.2.1",
    "@cds/core": "^6.15.1",
    "@clr/angular": "^17.7.1",
    "@clr/ui": "^17.7.1",
    "@danielmoncada/angular-datetime-picker": "^19.1.0",
    "@danielmoncada/angular-datetime-picker-moment-adapter": "^6.0.0",
    "@fullcalendar/angular": "^6.1.15",
    "@fullcalendar/core": "^6.1.15",
    "@fullcalendar/daygrid": "^6.1.15",
    "@fullcalendar/interaction": "^6.1.15",
    "@fullcalendar/list": "^6.1.15",
    "@fullcalendar/multimonth": "^6.1.15",
    "@fullcalendar/resource": "^6.1.20",
    "@fullcalendar/resource-timeline": "^6.1.20",
    "@fullcalendar/timegrid": "^6.1.15",
    "@kolkov/angular-editor": "^3.0.0-beta.2",
    "@ngneat/dialog": "^5.1.2",
    "date-fns": "^4.1.0",
    "date-fns-tz": "^3.2.0",
    "jwt-decode": "^4.0.0",
    "moment": "^2.30.1",
    "ngx-drag-drop": "^19.0.0",
    "pusher-js": "^8.4.0-rc2",
    "rxjs": "~7.8.0",
    "tippy.js": "^6.3.7",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.1",
    "@angular/cli": "^19.2.1",
    "@angular/compiler-cli": "^19.2.1",
    "@types/jasmine": "~5.1.0",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.8.2"
  }
}
